<template>
    <div :id="this.id"
         class="sitebuilder-element-container"
         element="MenuComponent"
         :data-tag="dataTag()"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
          :style="style()"  @mouseout="hideDropDown($event)">

        <nav class="navbar navbar-expand-lg desktop-menu-element" v-bind:style="{
        'cursor':'pointer',
        'border-radius': radius,
        backgroundColor: backgroundColor,
        border : border,
        cursor: 'pointer',
        'box-shadow': boxShadow,
      }">
            <div class="collapse navbar-collapse">
                <ul :class="vertical ? 'navbar-nav mr-auto flex-column' : 'navbar-nav mr-auto' ">
                    <li class="nav-item item-menu-sb" v-for="item in internal_config.itemList"
                        v-bind:style="{backgroundColor: backgroundColorItem}" >
                        <a :class="[item.children.length > 0 ? 'dropdown-toggle' : '', 'nav-link']"
                           data-toggle="dropdown" @click="clickDropDown(item.name, item)"
                           @mouseover="showDropDown(item.name, true)"
                           :id="item.children.length > 0 ? item.name:''"
                           v-on:mouseover="mouseover"
                           v-on:mouseleave="mouseleave"
                           :style="textStyle()">{{item.name}}</a>
                        <div class="dropdown-menu" v-if="item.children.length > 0" :ref="item.name"
                             v-bind:style="{backgroundColor: backgroundColorSubItem}">
                            <a class="dropdown-item" v-for="child in item.children" href="#"
                               :style="subTextStyle()"
                               @click="linkAction(child)"
                               v-on:mouseover="mouseSubOver"
                               v-on:mouseleave="mouseSubOut">{{child.name}}</a>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>

        <!-- Top Navigation Menu -->
        <div class="topnav  mobile-menu-element" v-bind:style="{backgroundColor: backgroundColor}">
            <div id="myLinks" ref="burguer">
                <div v-for="item in internal_config.itemList"  v-bind:style="{backgroundColor: backgroundColorItem}">
                    <a  :style="textStyle()" class="nav-link" v-on:mouseover="mouseover"
                       v-on:mouseleave="mouseleave" @click="linkAction(item)">{{item.name}}</a>
                    <a :style="subTextStyle()" class="burguer-sub-item dropdown-item" v-on:mouseover="mouseSubOver"
                       v-on:mouseleave="mouseSubOut" v-for="child in item.children" @click="linkAction(child)">{{child.name}}</a>
                </div>
            </div>
            <a href="javascript:void(0);" class="icon" @click="myFunction" ref="burguerMenu">
                <div class="mdi mdi-menu font-awesome-icon" style="font-size: 20px"></div>
                <!--                <font-awesome-icon :icon="['fas', 'bars']" class="font-awesome-icon"/>-->
            </a>
        </div>
    </div>
</template>

<script>

	import Data from './Model';
	import Resources from './Resources.vue';
	import {SweetModal} from 'sweet-modal-vue'

	export default {
		name: 'MenuComponent',
		props: ['config', 'id', 'preview'],
		components: {
			Data,
			Resources,
			SweetModal
		},
		computed: {
			vertical() {
				return this.internal_config.vertical;
			},
			border() {
				if (typeof this.internal_config.border !== 'undefined') {
					let splitedBorder = this.internal_config.border.split(' ');

					if (typeof splitedBorder[2] !== 'undefined' && this.$globalStoreHelpers.isValidHex(splitedBorder[2])) {
						splitedBorder[2] = this.$globalStoreHelpers.hexToRGBA(splitedBorder[2]);
						this.internal_config.border = splitedBorder.join(' ');
					}
				}
				return this.internal_config.border;
			},
			boxShadow() {
				return this.internal_config.boxShadow;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
			backgroundColor() {
				if (this.$globalStoreHelpers.isValidHex(this.internal_config.backgroundColor)) {
					this.internal_config.backgroundColor = this.$globalStoreHelpers.hexToRGBA(this.internal_config.backgroundColor);
				}
				return this.internal_config.backgroundColor;
			},
			backgroundColorItem() {
				if (this.$globalStoreHelpers.isValidHex(this.internal_config.btnStyle.backgroundColor)) {
					this.internal_config.btnStyle.backgroundColor = this.$globalStoreHelpers.hexToRGBA(this.internal_config.btnStyle.backgroundColor);
				}
				return this.internal_config.btnStyle.backgroundColor;
			},
			backgroundColorSubItem() {
				if (this.$globalStoreHelpers.isValidHex(this.internal_config.subStyle.backgroundColor)) {
					this.internal_config.subStyle.backgroundColor = this.$globalStoreHelpers.hexToRGBA(this.internal_config.subStyle.backgroundColor);
				}
				return this.internal_config.subStyle.backgroundColor;
			},
		},
		data() {
			return Data.data();
		},
		methods: {
			dataTag(){
				if (this.internal_config.tag) {
					return this.internal_config.tag;
				}
				return '';
			},
			buildMenu() {
				let burguerMenu = this.internal_config.burguerMenu;
				this.$refs.burguerMenu.style.right = burguerMenu == 'left' ? 'calc(100% - 58px)' : (burguerMenu == 'center' ? 'calc(50% - 29px)' : '0px');
			},

			animation() {
				return false;
			},
			myFunction() {
				let x = this.$refs.burguer;
				if (x.style.display === "block") {
					x.style.display = "none";
				} else {
					x.style.display = "block";
				}
			},


			mouseover(e) {
				let element = e.toElement;

				if (this.$globalStoreHelpers.isValidHex(this.internal_config.btnStyle.backgroundColorHover)) {
					this.internal_config.btnStyle.backgroundColorHover = this.$globalStoreHelpers.hexToRGBA(this.internal_config.btnStyle.backgroundColorHover);
				}

				if (element.classList.contains('nav-link'))
					element.style.backgroundColor = this.internal_config.btnStyle.backgroundColorHover;
			},

			mouseleave(e) {
				let element = e.fromElement;

				if (this.$globalStoreHelpers.isValidHex(this.internal_config.btnStyle.backgroundColor)) {
					this.internal_config.btnStyle.backgroundColor = this.$globalStoreHelpers.hexToRGBA(this.internal_config.btnStyle.backgroundColor);
				}

				if (element.classList.contains('nav-link'))
					element.style.backgroundColor = this.internal_config.btnStyle.backgroundColor;
			},
			mouseSubOver(e) {
				let element = e.toElement;

				if (this.$globalStoreHelpers.isValidHex(this.internal_config.subStyle.backgroundColorHover)) {
					this.internal_config.subStyle.backgroundColorHover = this.$globalStoreHelpers.hexToRGBA(this.internal_config.subStyle.backgroundColorHover);
				}

				if (element.classList.contains('dropdown-item'))
					element.style.backgroundColor = this.internal_config.subStyle.backgroundColorHover;
			},

			mouseSubOut(e) {
				let element = e.fromElement;

				if (this.$globalStoreHelpers.isValidHex(this.internal_config.subStyle.backgroundColor)) {
					this.internal_config.subStyle.backgroundColor = this.$globalStoreHelpers.hexToRGBA(this.internal_config.subStyle.backgroundColor);
				}

				if (element.classList.contains('dropdown-item'))
					element.style.backgroundColor = this.internal_config.subStyle.backgroundColor;
			},

			clickDropDown(id, item) {

				$('.dropdown-menu').hide();

				if (typeof this.$refs[id] !== 'undefined')
					this.$refs[id][0].style.display = this.$refs[id][0].style.display == 'none' ? 'block' : 'none';

				this.linkAction(item);
			},

			showDropDown(id, show) {

				$('.dropdown-menu').hide();

				if (typeof this.$refs[id] !== 'undefined')
					this.$refs[id][0].style.display = this.$refs[id][0].style.display == 'none' ? 'block' : 'none';

				if (typeof this.$refs[id] !== 'undefined')
					this.$refs[id][0].style.display = show ? 'block' : 'none';

			},

			hideDropDown(e){

				if(e.toElement.className == 'panel-body container'){
				    $('.dropdown-menu').hide();
                }
            },
			// linkElement: function () {
			// this.$root.$emit('linkComponentShow', this);
			// },

			linkAction: function (item) {


				// if (this.internal_config.link.type === 'video' && this.internal_config.link.value !== '') {
				//   this.$refs.videoModalIframe.src = this.internal_config.link.value;
				//   this.$refs.videoModal.open();
				// } else {
				this.$root.$emit('linkAction', item.link);
				// }

			},
			buildIcon: function () {

				$(this.$el).find('i').detach();

				if (this.internal_config.icon !== '') {
					if (this.internal_config.iconPosition === 'left') {
						$('<i>').addClass('mdi ' + this.internal_config.icon).prependTo($(this.$el).find('.sb-text').get(0));
					}
					if (this.internal_config.iconPosition === 'right') {
						$('<i>').addClass('mdi ' + this.internal_config.icon).appendTo($(this.$el).find('.sb-text').get(0));
					}
				}
			},
            build(config) {
				this.internal_config = config;
				console.log(config);

				this.buildIcon();
				this.buildMenu();
				this.applyCssSpacing()
			},
			textStyle() {
				return `font-family:  ${this.internal_config.btnStyle.family};
                 font-size: ${this.internal_config.btnStyle.size};
                 text-align: ${this.internal_config.btnStyle.align};
                 font-weight: ${this.internal_config.btnStyle.weight};
                 font-style: ${this.internal_config.btnStyle.style};
                 color: ${this.internal_config.btnStyle.color}`;
			},
			subTextStyle() {
				return `font-family:  ${this.internal_config.subStyle.family};
                 font-size: ${this.internal_config.subStyle.size};
                 text-align: ${this.internal_config.subStyle.align};
                 font-weight: ${this.internal_config.subStyle.weight};
                 font-style: ${this.internal_config.subStyle.style};
                 color: ${this.internal_config.subStyle.color}`;
			},
			style() {
				return `left:  ${this.internal_config.left};
                     z-index: ${this.internal_config.zIndex};
				        padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top}`;
			},
			styleResize() {
				return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
			},
			applyCssSpacing() {
				let vm = this;
				this.$nextTick(()=>{
					$(vm.$el).find('.item-menu-sb').css({
						marginLeft: parseInt(vm.internal_config.spacing) + 'px'
					});
				})
			},
		},
		mounted() {
			this.build(this.$props.config);

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

			this.$el.classList.add('preview');

			if(this.internal_config.zIndex === 'auto'){
				this.internal_config.zIndex = 1;
            }


			// this.$el.addEventListener('mouseover', function () {
			// 	document.body.style.setProperty('--button-background-color--hover', vm.internal_config.backgroundColorHover);
			// });
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .sitebuilder-element-container {
        width: auto !important;
        height: auto !important;

        .navbar {
            padding: 0;
            height: auto;
            white-space: nowrap;

            .item-menu-sb:first-of-type {
                margin-left: 0 !important;
            }
        }

        .navbar-nav .dropdown-menu {
            padding: 0;
        }

        .topnav {
            overflow: hidden;
            background-color: #333;
            position: relative;
            min-height: 57px;
            text-align: center;
            cursor: pointer;

            #myLinks {
                display: none;

                > :first-child {
                    margin-top: 57px;
                }
            }

            .burguer-sub-item {
                padding-left: 15px;
            }

            a {
                color: white;
                padding: 14px 16px;
                text-decoration: none;
                font-size: 17px;
                display: block;

                &.icon {
                    background: black;
                    display: block;
                    position: absolute;
                    right: 0;
                    top: 0;
                }

                &:hover {
                    background-color: #ddd;
                    color: black;
                }
            }
        }

        .active {
            background-color: #4CAF50;
            color: white;
        }
    }

    @media (max-width: 900px) {
        .desktop-menu-element {
            display: none;
        }

        .mobile-menu-element {
            display: block;
        }
    }

    @media (min-width: 989px) {
        .desktop-menu-element {
            display: block;
        }

        .mobile-menu-element {
            display: none;
        }
    }
</style>
<style lang="scss">

    .nav-item{
        position: relative !important;
    }

    .flex-column .dropdown-menu{
        left: 100%;
        top: 0;
    }
</style>
